import { render } from "./AddProductComponent.vue?vue&type=template&id=f295b7c2"
import script from "./AddProductComponent.vue?vue&type=script&lang=js"
export * from "./AddProductComponent.vue?vue&type=script&lang=js"

import "./AddProductComponent.vue?vue&type=style&index=0&id=f295b7c2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__